import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({
    url: '/travel/hacker/init',
    method: 'GET',
    params: { ...params, app_id: 67 }
  }, { interceptResultCode: false });
};

// 生成密令
export const onGenerationSecretAPI = (data) => {
  return axios({ url: '/travel/hacker/store', method: 'POST', data });
};

// 兑换密令
export const onExchangeSecretAPI = (data) => {
  return axios({ url: '/travel/hacker/update', method: 'POST', data });
};

// 领取奖励
export const onRewardAPI = (data) => {
  return axios({ url: '/travel/hacker/reward', method: 'POST', data });
};

// 帮助页初始化
export const getHelpInfoAPI = (params) => {
  return axios({ url: '/travel/hacker/help', method: 'GET', params }, { interceptResultCode: false });
};

// 帮助
export const onHelpAPI = (data) => {
  return axios({ url: '/travel/hacker/help', method: 'POST', data }, { interceptResultCode: false });
};


// WEBPACK FOOTER //
// ./src/pages/travel/hacker/api.js